import React, { useState } from "react";
import { useApp } from "context";
import { Custom, Item, Progress } from "components";
import { Grid } from "@mui/material";
import { IClinic } from "interfaces";

type Props = {
  sx?: any;
  opened: boolean;
  onClose?: () => void;
};

export const Clinic = (props: Props) => {
  const { t, theme, user, service } = useApp();

  const [clinics, setClinics] = useState<IClinic[]>([]);

  const handleOpen = async () => {
    const response = await service.clinic.all();
    setClinics(response);
  };

  return (
    <Custom.Modal
      opened={props.opened}
      onClose={props.onClose}
      header={t.title.patient.clinic}
      onOpen={handleOpen}
    >
      <Grid container spacing={theme.margin.md} sx={{ position: "relative" }}>
        {clinics && clinics.length > 0 ? (
          <Grid item xs={12}>
            {clinics.map((item: IClinic) => {
              return (
                item.clinicId !== user.userId && (
                  <Item.Clinic key={item.clinicId} clinic={item} />
                )
              );
            })}
          </Grid>
        ) : (
          <Progress.NoRecord
            height={200}
            message={t.message.placeholder.no_clinic}
          />
        )}
      </Grid>
    </Custom.Modal>
  );
};
